export default "__VITE_ASSET__WgCBXvte__"